import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from 'Context';
import { Pathname } from 'Routes';

// Hardcoded allow-list of accounts that get the Affiliate Program (and NOT User
// Management). Everyone else sees User Management, not Affiliate. Keep lowercase.
export const AFFILIATE_EMAILS = [
  // 'layne@projector.app',
  // 'becky@beacondigitalvideo.com',
  // 'rob@robmarks.com',
  // 'egranot@gmail.com',
  'newaccountfortest@yopmail.com',
  'newtestaff1@yopmail.com',
  'newaccounttwss@yopmail.com',
  'testaccocuntaff1@yopmail.com',
  'testaccocuntaff3@yopmail.com',
  'testaccocuntaff2@yopmail.com',
  'testaccocuntaff4@yopmail.com',
  'testaccocuntaff5@yopmail.com',
  'testaccocuntaff6@yopmail.com',
  'testaccocuntaff7@yopmail.com',
  'becky@beacondigitalvideo.com',
  'robmarks@me.com',
  'egranot@gmail.com',
  'layne@projector.app',
];

export const isAffiliateUser = (email) => !!email
  && AFFILIATE_EMAILS.includes(String(email).trim().toLowerCase());

// ── Route guards — block access via a direct URL. Render nothing until we know
// who the user is (avoids a wrong-page flash / redirect bounce during boot).
export const AffiliateOnly = ({ children }) => {
  const { userDetails } = useContext(AppContext);
  const email = userDetails?.email;
  if (!email) return null;
  return isAffiliateUser(email)
    ? children
    : <Navigate to={Pathname.getSettingsPath(Pathname.settings.manageUsers)} replace />;
};

export const ManageUsersOnly = ({ children }) => {
  const { userDetails } = useContext(AppContext);
  const email = userDetails?.email;
  if (!email) return null;
  return isAffiliateUser(email)
    ? <Navigate to={Pathname.getSettingsPath(Pathname.settings.affiliate)} replace />
    : children;
};
